<script>
  import {useParams} from "svelte-navigator"
  import AutoMpsProjectPageBase from "../../../../../../../auto-mps/AutoMpsProjectPageBase.svelte";
  import WithAutoMpsControlTab from "../../../../../../../auto-mps/WithAutoMpsControlTab.svelte";
  import ImportPage from "../../../../../../../auto-mps/imports/ImportPage.svelte";

  const params = useParams()

  const dataType = $params.dataType
  const importId = $params.importId
</script>

<AutoMpsProjectPageBase>
  <WithAutoMpsControlTab>
    <ImportPage dataType={dataType} importId={importId} />
  </WithAutoMpsControlTab>
</AutoMpsProjectPageBase>
